var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQrCodeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 49,
    viewBox: "0 0 65 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.6124 11.7759H43.1136L39.502 17.6765H44.6305C48.1506 17.6765 51.5266 18.982 54.0157 21.3058C56.5048 23.6296 57.9032 26.7813 57.9032 30.0677C57.9032 33.354 56.5048 36.5058 54.0157 38.8296C51.5266 41.1534 48.1506 42.4589 44.6305 42.4589H3.62956L0.0179443 48.3595H44.6124C49.8016 48.3595 54.7783 46.435 58.4476 43.0093C62.117 39.5837 64.1784 34.9375 64.1784 30.093C64.1784 25.2484 62.117 20.6022 58.4476 17.1766C54.7783 13.751 49.8016 11.8265 44.6124 11.8265V11.7759Z",
    fill: "#1A446F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6126 36.5836C46.4637 36.5836 48.2389 35.8971 49.5478 34.6751C50.8567 33.4532 51.5921 31.7958 51.5921 30.0677C51.5921 28.3395 50.8567 26.6822 49.5478 25.4602C48.2389 24.2383 46.4637 23.5518 44.6126 23.5518H35.8454L27.7825 36.5836H44.6126Z",
    fill: "#1A446F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.566 36.5836H21.0648L24.6764 30.683H19.566C16.0458 30.683 12.6698 29.3775 10.1807 27.0537C7.69162 24.7299 6.29325 21.5781 6.29325 18.2918C6.29325 15.0054 7.69162 11.8537 10.1807 9.52988C12.6698 7.20608 16.0458 5.90058 19.566 5.90058H60.5488L64.1604 0H19.566C14.3767 0 9.40006 1.9245 5.73073 5.35014C2.06141 8.77577 0 13.4219 0 18.2665C0 23.1111 2.06141 27.7572 5.73073 31.1829C9.40006 34.6085 14.3767 36.533 19.566 36.533V36.5836Z",
    fill: "#1A446F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5864 18.3171C12.5888 20.0445 13.3249 21.7006 14.6333 22.9221C15.9417 24.1436 17.7156 24.8308 19.5659 24.833H28.3331L36.3961 11.7759H19.5659C18.6474 11.777 17.7381 11.9471 16.8901 12.2765C16.0421 12.606 15.272 13.0882 14.6237 13.6958C13.9755 14.3033 13.4619 15.0241 13.1124 15.8171C12.7628 16.6101 12.5841 17.4596 12.5864 18.3171Z",
    fill: "#1A446F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeLogo);
export default __webpack_public_path__ + "static/media/QrCodeLogo.8f533a0cb6a3bf16cd4bd0a1e5fc90c1.svg";
export { ForwardRef as ReactComponent };